<template>
  <label class="bbp-search">
    <i class="bbp-icon-loupe bbp-search__icon"/>
    <input class="bbp-input bbp-search__input"
           type="text"
           placeholder="Search"
           v-model="inputValue"
           @input="emitValue">
  </label>
</template>

<script>
import {debounce} from 'lodash'

export default {
  name: 'BBPSearch',
  props: {
    value: String
  },
  data: () => ({
    inputValue: ''
  }),
  computed: {
    emitValue () {
      return debounce(this.getValue, 500)
    }
  },
  methods: {
    getValue (e) {
      const val = e.target.value
      this.$emit('change', val)
    }
  },
  beforeMount () {
    this.inputValue = this.value
  },
  watch: {
    value () {
      this.inputValue = this.value
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bbp-search {
    @include global-font;
    position: relative;
    display: flex;
    align-items: center;

    &__icon {
      position: absolute;
      left: 13px;
      color: $color-silver;
      pointer-events: none;
    }

    &__input {
      border: none;
      padding: 12px 12px 12px 40px;

      &::placeholder {
        color: $color-silver;
        font-weight: 500;
        transition: 0.3s;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/InputFields/BBPSearch/BBPSearch.vue